module.exports = __webpack_public_path__ + "static/media/successIcon.e37db155.svg";